import { render } from "./SmallPlatesBody.vue?vue&type=template&id=4e69d2c2&scoped=true"
import script from "./SmallPlatesBody.vue?vue&type=script&lang=js"
export * from "./SmallPlatesBody.vue?vue&type=script&lang=js"

import "./SmallPlatesBody.vue?vue&type=style&index=0&id=4e69d2c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e69d2c2"]])

export default __exports__